module.exports = "https://static.wmbcdn.com/uniweb/images/5f7e35ab464772f547625f0e13f6b80e.svg";